import { createSelector } from 'reselect'
import getSubscriptionInfoByIdVariantSelector from 'modules/variant/redux/selectors/subscription-info/get-subscription-info-by-id'
import { flatten } from 'lodash'

/**
 * @param variantId
 */
const getSubscriptionSellingPlansByIdVariantSelector = variantId => createSelector(
  getSubscriptionInfoByIdVariantSelector(variantId),
  /**
   * @param {VariantSubscriptionInfo} subscriptionInfo
   * @return {SellingPlanDisplayInfo[]}
   */
  subscriptionInfo => (
    flatten(
      subscriptionInfo?.selling_plans
    )
  )
)

export default getSubscriptionSellingPlansByIdVariantSelector
